module.exports = __webpack_public_path__ + "static/media/boss-bar-red-11.22963a49.png";